import * as React from 'react'

import moment from 'moment'

import type { Moment } from 'moment'

import { DailyPartialRegularRestEventModel } from 'app/models/dailyPartialRegularRestModel'
import { BaseEventModel } from 'app/models/baseEventModel'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'
import { PRINT_BAR_OUTLINE } from '../printStyles'
import { useRestLanes } from '../context/LanesContext'
import { BOTTOM_PADDING } from '../utils/layout'

export type DailyPartialRegularRestBlockProps = {
  dailyPartialRegularRest: DailyPartialRegularRestEventModel
  index: number
}

const color = '#6A1B9A'

const prepareTooltipInfo = (
  startTime: Moment,
  endTime: Moment,
): BaseEventModel => {
  const info: BaseEventModel = {
    startTime: startTime,
    endTime: endTime,
    typeName: 'eventName.dailyPartialRegularRest',
    color: color,
  }
  return info
}

export const DailyPartialRegularRestBlock: React.FC<DailyPartialRegularRestBlockProps> =
  React.memo((props: DailyPartialRegularRestBlockProps) => {
    const scene = useScene()
    const { printMode } = useConfig()
    const { restLaneFor, restIsTop } = useRestLanes()

    const renderDailyPartialItem = (firstPart: boolean) => {
      const HEIGHT = scene.height - 54
      const dailyPartialRegularRest = props.dailyPartialRegularRest

      const startTime = moment(
        firstPart
          ? dailyPartialRegularRest.startTime
          : dailyPartialRegularRest.secondPartRestStartTime,
      )
      const endTime = moment(
        firstPart
          ? dailyPartialRegularRest.firstPartRestEndTime
          : dailyPartialRegularRest.formalRestEndDate,
      )

      const itemWidth = scene.widthOf(startTime, endTime)

      if (itemWidth <= 0) {
        return null
      }

      const position = scene.timeToX(startTime)

      const itemHeight = HEIGHT / 4

      let fontSize = itemHeight
      if (fontSize > 11) {
        fontSize = 11
      }

      let fontMarginTop = 0
      if (fontSize < itemHeight) {
        fontMarginTop = (itemHeight - fontSize) / 2
      }

      const lane = restLaneFor(startTime, endTime)
      const isTop = restIsTop(startTime, endTime)

      return (
        <div
          className="tw-flex tw-flex-col tw-items-start tw-justify-end"
          style={{
            left: position,
            top: 0,
            bottom: 0,
            position: 'absolute',
            paddingBottom: BOTTOM_PADDING,
          }}
        >
          <div
            style={{
              background: color,
              boxShadow: printMode ? PRINT_BAR_OUTLINE : undefined,
              borderColor: '#000000',
              pointerEvents: 'auto',
              width: itemWidth,
              height: 6,
              marginBottom: lane * 6,
              borderTopLeftRadius: isTop ? 3 : 0,
              borderTopRightRadius: isTop ? 3 : 0,
              paddingTop: 1,
            }}
            data-tip={JSON.stringify(prepareTooltipInfo(startTime, endTime))}
            data-for="eventTooltip"
          >
          </div>
        </div>
      )
    }

    return (
      <div>
        {renderDailyPartialItem(true)}
        {renderDailyPartialItem(false)}
      </div>
    )
  })

DailyPartialRegularRestBlock.displayName = 'DailyPartialRegularRestBlock'
